const MESSAGES = {
  SESSION_TIMED_OUT: 'Session has timed out.',
  SESSION_MISMATCH: 'Session mismatch, please login again to verify authentication.',
  NEW_VERSION: 'A new version of the application is available. The page will soon be reloaded.',
};

export { MESSAGES };
